import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getLanguageList } from 'i18n/options';
import useUniqueId from 'hooks/useUniqueId';
import Card from 'components/Card';
import Button from 'components/Button';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import Panel from 'components/Panel';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import { Option, Select } from 'components/Select';
import { PanelTitle } from 'components/InspectorPanel';
import SubtitlesUploader from './SubtitlesUploader';
function getSubtitlesDownloadLink(_ref) {
  var assetId = _ref.assetId,
    subtitlesId = _ref.subtitlesId;
  return "/api/asset/".concat(assetId, "/subtitles/").concat(subtitlesId, "?download");
}
function SubtitlesEditor(_ref2) {
  var subtitleFile = _ref2.subtitleFile,
    assetId = _ref2.assetId,
    onCreate = _ref2.onCreate,
    onUpdate = _ref2.onUpdate,
    _ref2$isDisabled = _ref2.isDisabled,
    isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
    onClose = _ref2.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var languageList = getLanguageList();
  var selectableLanguages = [{
    title: t('actions_select_language'),
    value: ''
  }].concat(_toConsumableArray(languageList));
  var isUpdate = !!subtitleFile;
  var title = isUpdate ? t('actions_edit_subtitles') : t('actions_add_subtitles');
  var action = isUpdate ? t('actions_save') : "+ ".concat(t('actions_add_subtitle'));
  var _useState = useState(isUpdate ? subtitleFile.locale : ''),
    _useState2 = _slicedToArray(_useState, 2),
    language = _useState2[0],
    setLanguage = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    file = _useState4[0],
    setFile = _useState4[1];
  var isActionDisabled = isUpdate ? !language || language === subtitleFile.locale : !language || !file;
  function submit(event) {
    event.preventDefault();
    event.stopPropagation();
    if (subtitleFile && language !== '') {
      if (onUpdate) {
        onUpdate({
          id: subtitleFile.id,
          language: language
        });
      }
    } else if (file && onCreate && language !== '') {
      onCreate({
        file: file,
        language: language
      });
    }
    onClose();
  }
  var locale = languageList.find(function (_ref3) {
    var value = _ref3.value;
    return value === language;
  });
  var readableLanguage = locale === null || locale === void 0 ? void 0 : locale.title;
  var titleId = useUniqueId();
  return /*#__PURE__*/React.createElement(Modal, {
    "aria-labelledby": titleId,
    onRequestClose: onClose
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    as: "form",
    onSubmit: submit
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: title,
    titleId: titleId,
    onClose: onClose
  }), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(PanelTitle, {
    mb: "xs"
  }, t('subtitles_file')), !subtitleFile && /*#__PURE__*/React.createElement(SubtitlesUploader, {
    onSelect: setFile
  }), subtitleFile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "xs"
  }, subtitleFile.name || subtitleFile.filename), /*#__PURE__*/React.createElement(TextLink, {
    download: true,
    href: getSubtitlesDownloadLink({
      assetId: assetId,
      subtitlesId: subtitleFile.id
    }),
    title: t('actions_download_subtitle')
  }, t('actions_download')))), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(PanelTitle, {
    mb: "xs",
    id: "subtitle_language"
  }, t('panel_subtitles_language_title')), !isDisabled ? /*#__PURE__*/React.createElement(Select, {
    id: "subtitle_language_dropdown",
    labelledById: "subtitle_language",
    value: language,
    onChange: function onChange(value) {
      return setLanguage(value);
    },
    size: "medium"
  }, selectableLanguages.map(function (item) {
    return /*#__PURE__*/React.createElement(Option, {
      key: item.value,
      value: item.value
    }, item.title);
  })) : /*#__PURE__*/React.createElement(Text, {
    as: "div",
    size: "s"
  }, readableLanguage)), !isDisabled && /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "important",
    isDisabled: isActionDisabled
  }, action))));
}
export default SubtitlesEditor;